module.exports = __webpack_public_path__ + "1dafc3e77d67365a2c11a1047f4e7e51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2.jpg
// module id = 219
// module chunks = 0